import { useEffect, useState } from 'react';
import { Pouzivatel } from '../../../../model/iam/Pouzivatel';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClient } from '../../../../context/ClientStatusContext';
import { fetchZodpovednyPredkladatelList }
  from '../../../../client/legislativnyMaterial/zodpovednyPredkladatelClient';

interface ReturnType {
  pouzivatelia: Pouzivatel[];
  pouzivateliaStatus: ClientStatus;
}

export default (nameSearch: string, limit: number, execute = true): ReturnType => {
  const [, setAction] = useState<NodeJS.Timeout>(undefined);
  const {
    wrapClient,
    data,
    status,
  } = useClient(fetchZodpovednyPredkladatelList);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      if (execute) {
        await wrapClient(nameSearch, limit);
      }
    }, 300);

    setAction(act);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameSearch, limit, execute]);

  return {
    pouzivatelia: data || [],
    pouzivateliaStatus: status,
  };
};
